<template>
  <div
    class="gc-loading-overlay"
    :class="[
      'gc-loading-overlay--' + normalizedMode,
      {
        'is-compact': compact,
        'is-clear': clear
      }
    ]"
    :style="overlayStyle"
    aria-live="polite"
    aria-busy="true"
  >
    <Loader />
  </div>
</template>

<script>
import Loader from './loader.vue'

export default {
  name: 'LoadingOverlay',
  components: {
    Loader
  },
  props: {
    mode: {
      type: String,
      default: 'overlay'
    },
    minHeight: {
      type: [String, Number],
      default: ''
    },
    compact: {
      type: Boolean,
      default: false
    },
    clear: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    normalizedMode () {
      return this.mode === 'block' ? 'block' : 'overlay'
    },
    overlayStyle () {
      if (!this.minHeight) return null
      const value = typeof this.minHeight === 'number' ? this.minHeight + 'px' : this.minHeight
      return { minHeight: value }
    }
  }
}
</script>

<style scoped>
.gc-loading-overlay {
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 260px;
  padding: 1.5rem;
  border-radius: 8px;
  background:
    radial-gradient(circle at 50% 18%, rgba(25, 151, 198, 0.18), transparent 32%),
    rgba(4, 8, 14, 0.44);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.035);
  backdrop-filter: blur(2px);
}

.gc-loading-overlay--overlay {
  position: absolute;
  inset: 0;
}

.gc-loading-overlay--block {
  position: relative;
  min-height: 280px;
  border: 1px solid rgba(67, 72, 87, 0.78);
  background:
    radial-gradient(circle at 50% 18%, rgba(25, 151, 198, 0.14), transparent 34%),
    rgba(8, 10, 15, 0.42);
}

.gc-loading-overlay.is-clear {
  border: 0;
  background: transparent;
  box-shadow: none;
  backdrop-filter: none;
}

.gc-loading-overlay.is-compact {
  min-height: 220px;
  padding: 1rem;
}

.gc-loading-overlay >>> .loader {
  position: static !important;
  width: 128px !important;
  height: 128px !important;
  border: 1px solid rgba(25, 151, 198, 0.42);
  border-radius: 8px;
  background:
    radial-gradient(circle at 50% 34%, rgba(25, 151, 198, 0.2), transparent 58%),
    rgba(9, 13, 21, 0.74);
  opacity: 1 !important;
  box-shadow:
    0 18px 45px rgba(0, 0, 0, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

.gc-loading-overlay >>> .loading-spinner {
  position: static !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
}

.gc-loading-overlay >>> .spinner {
  margin-top: 0 !important;
}

.gc-loading-overlay >>> .message {
  display: none;
}

@media (max-width: 760px) {
  .gc-loading-overlay {
    min-height: 220px;
    padding: 1rem;
  }

  .gc-loading-overlay >>> .loader {
    width: 108px !important;
    height: 108px !important;
  }
}
</style>
